import React, { useEffect, useState } from "react";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Card,
  Modal,
  Table,
} from "react-bootstrap";
import ganesha from "../../images/ganesha.jpg";
import { vasthuUrl } from "../../component/Api";
import { UseAuth } from "../../context/Auth";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import Astro_spin from "../../images/Astro_spin.png";
import Toast from "../../component/Toast";
import { useNavigate } from "react-router-dom";

const southChartOrder = [
  12,
  1,
  2,
  3,
  11,
  null,
  null,
  4,
  10,
  null,
  null,
  5,
  9,
  8,
  7,
  6,
];

const convertRasiChakraToMap = (rasiChakraArray) => {
  const map = {};
  rasiChakraArray.forEach((rasi) => {
    map[rasi.rasiNumber] = {
      planets: rasi.planets,
      rasi: rasi.rasi,
    };
  });
  return map;
};

const convertNavamsaChartToMap = (navamsaChart, language) => {
  const rasiMap = {};

  const planetNameTamilMap = {
    Sun: "சூரியன்",
    Moon: "சந்திரன்",
    Mars: "செவ்வாய்",
    Mercury: "புதன்",
    Jupiter: "குரு",
    Venus: "சுக்ரன்",
    Saturn: "சனி",
    Rahu: "ராகு",
    Ketu: "கேது",
    Ascendant: "லக்னம்",
  };

  Object.entries(navamsaChart).forEach(([planet, rasi]) => {
    if (!rasiMap[rasi]) {
      rasiMap[rasi] = {
        planets: [],
        rasi,
      };
    }
    const displayPlanet =
      language === "ta" ? planetNameTamilMap[planet] || planet : planet;
    rasiMap[rasi].planets.push(displayPlanet);
  });

  const rasiNameToNumber = {
    Aries: 1,
    Taurus: 2,
    Gemini: 3,
    Cancer: 4,
    Leo: 5,
    Virgo: 6,
    Libra: 7,
    Scorpio: 8,
    Sagittarius: 9,
    Capricorn: 10,
    Aquarius: 11,
    Pisces: 12,
    மேஷம்: 1,
    ரிஷபம்: 2,
    மிதுனம்: 3,
    கடகம்: 4,
    சிம்மம்: 5,
    கன்னி: 6,
    துலாம்: 7,
    விருச்சிகம்: 8,
    தனுசு: 9,
    மகரம்: 10,
    கும்பம்: 11,
    மீனம்: 12,
  };

  const result = {};
  Object.entries(rasiMap).forEach(([rasi, data]) => {
    const rasiNum = rasiNameToNumber[rasi];
    if (rasiNum) {
      result[rasiNum] = data;
    }
  });

  return result;
};

const planetIconMap = {
  Sun: "☀️",
  Moon: "🌙",
  Mars: "♂️",
  Mercury: "☿️",
  Jupiter: "♃",
  Venus: "♀️",
  Saturn: "♄",
  Rahu: "☊",
  Ketu: "☋",
  Lagna: "🔸",
  சூரியன்: "☀️",
  சந்திரன்: "🌙",
  செவ்வாய்: "♂️",
  புதன்: "☿️",
  குரு: "♃",
  சுக்ரன்: "♀️",
  சனி: "♄",
  ராகு: "☊",
  கேது: "☋",
  லக்னா: "🔸",
};

const RasiChart = ({
  bhavas = {},
  userName,
  birthState,
  birthDate,
  birthTime,
  nakshatra,
  type,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "20px",
      }}
    >
      <div
        style={{
          position: "relative",
          width: 360,
          height: 360,
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gridTemplateRows: "repeat(4, 1fr)",
          border: "2px solid #c67b2b",
          backgroundColor: "#c67b2b",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "55%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            zIndex: 3,
            width: "120px",
            height: "130px",
            pointerEvents: "none",
          }}
        >
          <img
            src={ganesha}
            alt="Ganesha"
            style={{
              position: "absolute",
              top: -35,
              left: 0,
              width: "100%",
              height: "100%",
              opacity: 0.3,
            }}
          />
          <div
            style={{
              zIndex: 2,
              color: "#000",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          >
            <div style={{ whiteSpace: "nowrap" }}>
              <b>
                {" "}
                {t("TXT.NM.LO")}: {userName}
              </b>
            </div>
            <div style={{ whiteSpace: "nowrap" }}>
              <b>
                {" "}
                {t("CON.STATE")}: {birthState.split(",")[0]}
              </b>
            </div>
            <div style={{ whiteSpace: "nowrap" }}>
              <b>
                {" "}
                {t("CON.APMT.STUS.DATE")}:{" "}
                {dayjs(birthDate).format("DD-MM-YYYY")}
              </b>
            </div>
            <div style={{ whiteSpace: "nowrap" }}>
              <b>
                {" "}
                {t("CON.BRTH.TIME")}:{" "}
                {dayjs(birthTime, "HH:mm:ss").format("hh:mm A")}
              </b>
            </div>
            <div style={{ whiteSpace: "nowrap" }}>
              <b style={{ color: "#f32d00ff",fontSize:"16px" }}>
                {type === "Navamsa" ? t("CON.NAVAMSA") : t("CON.RASI")}
              </b>
              <br /> {nakshatra}
            </div>
          </div>
        </div>

        {southChartOrder.map((bhavaNum, index) => {
          const bhava = bhavaNum ? bhavas[bhavaNum] : null;
          const planets = bhava?.planets || [];
          console.log("planets", planets);
          const noBorderIndices = [5, 6, 9, 10];

          return (
            <div
              key={index}
              style={{
                backgroundColor: "#fffaf0",
                border: noBorderIndices.includes(index)
                  ? "none"
                  : "1px solid #c67b2b",
                fontSize: "11px",
                textAlign: "center",
                padding: "3px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2,
                position: "relative",
              }}
            >
              {bhavaNum && (
                <>
                  <div style={{ fontWeight: "bold" }}>{bhavaNum}</div>
                  <div
                  // style={{ whiteSpace: "pre-line" }}
                  >
                    {planets.join("\n")}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const spinnerOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(156, 146, 146, 0.8)",
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const PanchangamView = () => {
  const { t, i18n } = useTranslation();
  const { token } = UseAuth();
  const Navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [birthState, setBirthState] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [birthTime, setBirthTime] = useState("");
  const [language, setLanguage] = useState(i18n.language);
  const [panchangamData, setPanchangamData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchLocation, setSearchLocation] = useState("");
  const [results, setResults] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // ALERT MODAL
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  const alert = (msg) => {
    setMessage(msg);
    setToastTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    const fetchSuggestions = async () => {
      if (!searchLocation || !token) return;

      try {
        const response = await vasthuUrl.get("/api/vasthu/searchLocation", {
          headers: { Authorization: `Bearer ${token}` },
          params: { keyword: searchLocation, lang: language },
        });
        setResults(response.data);
        setShowSuggestions(true);
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    const delayDebounce = setTimeout(fetchSuggestions, 300);
    return () => clearTimeout(delayDebounce);
  }, [searchLocation, language, token]);

  const handleClose = () => {
    setUserName("");
    setSearchLocation("");
    setBirthDate("");
    setBirthTime("");
    localStorage.setItem("i18nextLng", "en");
    i18n.changeLanguage("en");
    setLanguage("en");
    setShowModal(false);
  };

  useEffect(() => {
    vasthuUrl.get("openapi/lang/allCode").then((res) => {
      console.log("available lang", res.data);
    });
  }, [i18n.language]);

  const handleSelectSuggestion = (place) => {
    setSearchLocation(place);
    setBirthState(place);
    setShowSuggestions(false);
  };

  // Load modal state and data from localStorage
  useEffect(() => {
    const savedModalState = localStorage.getItem("myModalOpen");
    const savedData = localStorage.getItem("panchangamData");

    if (savedModalState === "true" && savedData) {
      setPanchangamData(JSON.parse(savedData));
      setShowModal(true);
    }
    // Load form fields from localStorage if available
    const savedFormData = JSON.parse(localStorage.getItem("birthFormData"));
    if (savedFormData) {
      setUserName(savedFormData.userName || "");
      setBirthState(savedFormData.birthState || "");
      setBirthDate(savedFormData.birthDate || "");
      setBirthTime(savedFormData.birthTime || "");
    }
  }, []);

  // useEffect(() => {
  //   const savedModalState = localStorage.getItem("myModalOpen");
  //   if (savedModalState === "true") {
  //     setShowModal(true);
  //   }

  //   // Load form fields from localStorage if available
  //   const savedFormData = JSON.parse(localStorage.getItem("birthFormData"));
  //   if (savedFormData) {
  //     setUserName(savedFormData.userName || "");
  //     setBirthState(savedFormData.birthState || "");
  //     setBirthDate(savedFormData.birthDate || "");
  //     setBirthTime(savedFormData.birthTime || "");
  //   }
  // }, []);

  // Persist modal open/close state
  useEffect(() => {
    localStorage.setItem("myModalOpen", showModal);
  }, [showModal]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!birthTime || !birthDate || !userName || !birthState) {
      setMessageType("error");
      alert("All fields are required.");
      return;
    }

    // Save form fields so they persist
    localStorage.setItem(
      "birthFormData",
      JSON.stringify({ userName, birthState, birthDate, birthTime })
    );

    setLoading(true);
    const payload = {
      userName,
      userBirthstate: birthState,
      birthDate,
      birthTime,
      lang: language,
    };

    try {
      const res = await vasthuUrl.post("/api/astro/generate", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPanchangamData(res.data);
      localStorage.setItem("panchangamData", JSON.stringify(res.data));
      setShowModal(true);
    } catch (err) {
      console.error("Error fetching Panchangam data", err);
      alert("An error occurred. Please try again later.");
      setMessageType("error");
    }
    setLoading(false);
  };

  const planetaryDetails = panchangamData.planetaryDetails || [];
  const vimshottariDashaDetails = panchangamData.vimshottariDasha || [];

  return (
    <>
      <Toast msg={message} type={messageType} trigger={toastTrigger} />
      {loading && (
        <div style={spinnerOverlayStyle}>
          <img
            src={Astro_spin}
            alt="Loading..."
            style={{
              width: "350px",
              height: "350px",
              animation: "spin 10s linear infinite",
              display: "block",
              margin: "auto",
            }}
          />
        </div>
      )}
      <Container fluid className="mt-1 panchangam-bg">
        <center className="mb-4">
          <h2>{t("CON.GET.UR.BRT.CHT.PREDIONS")}</h2>
        </center>

        <Card
          className="p-4 shadow-lg"
          style={{ backgroundColor: "#ffffff8f" }}
        >
          <h4 className="mb-4 text-center">{t("CON.EN.UR.BRTH.DETS")}</h4>

          <Form.Group controlId="language" className="mb-4">
            <Form.Label>{t("CM.CNSL.ON.SER2")}</Form.Label>
            <Form.Select
              className="form_feild"
              value={language}
              onChange={(e) => {
                const newLang = e.target.value;
                setLanguage(newLang);
                localStorage.setItem("i18nextLng", newLang);
                i18n.changeLanguage(newLang);
              }}
            >
              <option value="ta">தமிழ்</option>
              <option value="en">English</option>
            </Form.Select>
          </Form.Group>

          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="userName">
                  <Form.Label>{t("PR.AC.PMTTAB.TBL.CLMN.NM")}</Form.Label>
                  <Form.Control
                    type="text"
                    className="form_feild"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    placeholder={t("USR.VSH.HFTAB.HO.PH")}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="birthDate">
                  <Form.Label>{t("USR.CON.SCH.USR.BIR.DAT")}</Form.Label>
                  <Form.Control
                    type="date"
                    className="form_feild"
                    value={birthDate}
                    onChange={(e) => setBirthDate(e.target.value)}
                    required
                    max={new Date().toISOString().split("T")[0]}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="birthTime">
                  <Form.Label>{t("USR.CON.SCH.USR.BIR.TIM")}</Form.Label>
                  <TimePicker
                    value={birthTime ? dayjs(birthTime, "HH:mm:ss") : null}
                    onChange={(time) =>
                      setBirthTime(time ? time.format("HH:mm:ss") : "")
                    }
                    format="hh:mm:A"
                    use12Hours
                    className="form_feild"
                    style={{
                      width: "100%",
                      height: "38px",
                      borderRadius: "5px",
                    }}
                    placeholder={t("CON.ENTER.BRTH.TIME")}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <div style={{ position: "relative" }}>
                  <Form.Group
                    controlId="formLocation"
                    style={{ position: "relative" }}
                  >
                    <Form.Label>{t("USR.CON.SCH.USR.BIR.PLA")}</Form.Label>
                    <Form.Control
                      type="text"
                      className="form_feild"
                      placeholder={t("USR.ENTER.BRTH.PLC")}
                      value={searchLocation}
                      onChange={(e) => setSearchLocation(e.target.value)}
                      autoComplete="off"
                    />
                    {searchLocation && (
                      <span
                        onClick={() => setSearchLocation("")}
                        style={{
                          position: "absolute",
                          right: 10,
                          top: "74%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          fontSize: "1.2rem",
                          color: "#aaa",
                        }}
                      >
                        &times;
                      </span>
                    )}
                  </Form.Group>

                  {showSuggestions && results.length > 0 && (
                    <ul
                      style={{
                        listStyleType: "none",
                        padding: 0,
                        marginTop: "4px",
                        border: "1px solid #ccc",
                        maxHeight: "150px",
                        overflowY: "auto",
                        position: "absolute",
                        width: "100%",
                        backgroundColor: "#fff",
                        zIndex: 999,
                      }}
                    >
                      {results.map((place, index) => (
                        <li
                          key={index}
                          onClick={() => handleSelectSuggestion(place)}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                        >
                          {place}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Col>
            </Row>

            <div className="d-flex justify-content-center gap-5 flex-row">
              <Button className="all_btn1" onClick={() => Navigate(-1)}>
                {t("TXT.CLO.LO")}
              </Button>
              <Button className="all_btn1" type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </>
                ) : (
                  t("CON.VIEW.BRTH.CHAT")
                )}
              </Button>
            </div>
          </Form>
        </Card>

        {showModal && (
          <Modal
            show={showModal}
            onHide={handleClose}
            size="lg"
            centered
            fullscreen
          >
            <Modal.Header className="all_background" closeButton>
              <Modal.Title>{t("USR.GET.BRTH.CHART.ALT")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {panchangamData && (
                <div>
                  {" "}
                  <center>
                    <h3>{t("CON.JATHAGAM")}</h3>
                  </center>
                  <div className="mt-1 d-flex justify-content-center gap-3">
                    <RasiChart
                      bhavas={convertRasiChakraToMap(
                        panchangamData.rasiChakra || []
                      )}
                      userName={userName}
                      birthState={birthState}
                      birthDate={birthDate}
                      birthTime={birthTime}
                      nakshatra={panchangamData.nakshatra}
                    />
                    <RasiChart
                      bhavas={convertNavamsaChartToMap(
                        panchangamData.navamsaChart || [],
                        language
                      )}
                      userName={userName}
                      birthState={birthState}
                      birthDate={birthDate}
                      birthTime={birthTime}
                      nakshatra={panchangamData.nakshatra}
                      type="Navamsa"
                    />
                  </div>
                  <center>
                    <h2 className="py-2">
                      <u>{t("USR.BRTH.TXT")}</u>
                    </h2>
                  </center>
                  <Table
                    style={{ border: "1px solid #000000" }}
                    striped
                    bordered
                    hover
                    responsive
                    className="mt-1"
                  >
                    <tbody className="text-center">
                      <tr>
                        <th> {t("CON.RASI")}</th>
                        <td>{panchangamData.rasi}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.RASI.LORD")}</th>
                        <td>{panchangamData.rasiLord}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.LAGNA")}</th>
                        <td>{panchangamData.lagna}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.LAG.LORD")}</th>
                        <td>{panchangamData.lagnaLord}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.NAKSHATRA")}</th>
                        <td>{panchangamData.nakshatra}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.NAKS.PADA")}</th>
                        <td>{panchangamData.nakshatraPada}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.NAK.LORD")}</th>
                        <td>{panchangamData.nakshatraLord}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.THITHI")}</th>
                        <td>{panchangamData.tithi}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.THITHI.PAK")}</th>
                        <td>{panchangamData.tithiPaksha}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.THITHI.SUNYAM")}</th>
                        <td>{panchangamData.tithiSuniyam}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.KARNA")}</th>
                        <td>{panchangamData.karana}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.YOGA")}</th>
                        <td>{panchangamData.yoga}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.YOGA.DEVA")}</th>
                        <td>{panchangamData.yogaDevata}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.WEEK.DAY")}</th>
                        <td>{panchangamData.weekday}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.SUN.RISE")}</th>
                        <td>{panchangamData.sunrise}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.SUN.SET")}</th>
                        <td>{panchangamData.sunset}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.AYAMSA")}</th>
                        <td>{panchangamData.ayanamsa}</td>
                      </tr>
                      {/* <tr>
                        <th> {t("CON.MOON.LOG")}</th>
                        <td>{panchangamData.moonLongitude}</td>
                      </tr>     */}
                      <tr>
                        <th> {t("CON.GANAM")}</th>
                        <td>{panchangamData.ganam}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.YONI")}</th>
                        <td>{panchangamData.yoni}</td>
                      </tr>
                      {/* <tr>
                        <th> {t("CON.PRE.DEITY")}</th>
                        <td>{panchangamData.setpresidingDeity}</td>
                      </tr> */}
                      {/* <tr>
                        <th> {t("CON.ANIMAL.SIGN")}</th>
                        <td>{panchangamData.animalSign}</td>
                      </tr> */}
                      <tr>
                        <th> {t("CON.THEERKA.AMSAM")}</th>
                        <td>{panchangamData.theerkaAmsam}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.CURT.AGE")}</th>
                        <td>{panchangamData.currentAge}</td>
                      </tr>
                      <tr>
                        <th> {t("CON.DA.BALN.DYS")}</th>
                        <td>{panchangamData.dasaBalanceDays}</td>
                      </tr>
                    </tbody>
                  </Table>
                  <center>
                    <h2 className="py-2">
                      <u>{t("CON.PLNT.POSTION")}</u>
                    </h2>
                  </center>
                  <Table
                    style={{ border: "1px solid #000000" }}
                    bordered
                    responsive
                    hover
                  >
                    <thead>
                      <tr className="table_header">
                        <th>{language === "ta" ? "கிரகம்" : "Planet"}</th>
                        <th>
                          {language === "ta" ? "நீளம்" : "Latitude Degree"}
                        </th>
                        <th>{language === "ta" ? "ராசி" : "Rasi"}</th>
                        <th>
                          {language === "ta" ? "ராசி டிகிரி" : "Rasi Degree"}
                        </th>
                        <th>
                          {language === "ta"
                            ? "நட்சத்திர பாதம்"
                            : "Nakshatra Pada"}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {planetaryDetails &&
                        planetaryDetails.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {planetIconMap[item.planetName] || "🔹"}&nbsp;
                              {item.planetName}
                            </td>
                            <td>{item.latDegree}</td>
                            <td>{item.rasi}</td>
                            <td>{item.rasiDegree}</td>
                            <td>{item.nakshatraPada}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                  <center>
                    <h2>{t("CON.VIMSHOT.DASH.DTS")}</h2>
                  </center>
                  <Table
                    style={{ border: "1px solid #000000" }}
                    bordered
                    responsive
                    hover
                  >
                    <thead>
                      <tr className="table_header">
                        <th>{t("CON.MAHADASA")}</th>
                        <th>{t("CON.ANTRDASA")}</th>
                        <th>{t("CON.START.DATE")}</th>
                        <th>{t("CON.END.DATE")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vimshottariDashaDetails &&
                        vimshottariDashaDetails.map((item, index) => (
                          <tr key={index}>
                            <td data-label="Mahadasha">{item.mahadasha}</td>
                            <td data-label="Antardasha">{item.antardasha}</td>
                            <td data-label="Start">
                              {dayjs(item.start).format("DD-MM-YYYY")}
                            </td>
                            <td data-label="End">
                              {dayjs(item.end).format("DD-MM-YYYY")}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </Modal.Body>
          </Modal>
        )}
      </Container>
    </>
  );
};

export default PanchangamView;
